<!-- src/views/Home.vue -->
<template>
  <div>
    <ContentBlockList />
  </div>
</template>

<script>
import ContentBlockList from '../components/ContentBlockList.vue';

export default {
  components: {
    ContentBlockList,
  },
  name: 'HomePage',
};
</script>
